import { render, staticRenderFns } from "./Error404.vue?vue&type=template&id=c06a6578&scoped=true&"
import script from "./Error404.vue?vue&type=script&lang=js&"
export * from "./Error404.vue?vue&type=script&lang=js&"
import style0 from "./Error404.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Error404.vue?vue&type=style&index=1&id=c06a6578&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06a6578",
  null
  
)

export default component.exports